module.exports = __webpack_public_path__ + "static/media/hand-holding-usd.944e6ea2.svg";